import { render, staticRenderFns } from "./tour.vue?vue&type=template&id=11ef2086&"
import script from "./tour.vue?vue&type=script&lang=js&"
export * from "./tour.vue?vue&type=script&lang=js&"
import style0 from "./tour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports